import axios from "axios";
import createRestApiClient from "../../utility/createRestApiClient";

import { DEFAULT_TEST_DATA_API_CALL_LIMIT } from "../../common/constants/View";
import {
  FETCH_FLAXY_TESTS_IN_BUILD_FAILED,
  FETCH_FLAXY_TESTS_IN_BUILD_LOADING,
  FETCH_FLAXY_TESTS_IN_BUILD_SUCCESS,
  LAMBDATEST_DELETE_TEST_LOCAL,
  LAMBDATEST_SSE_TEST_LIST_DATA_UPDATE,
  LAMBDATEST_TEST_DATA_ADD,
  LAMBDATEST_TEST_DATA_CLEAR,
  LAMBDATEST_TEST_DATA_FAILED,
  LAMBDATEST_TEST_DATA_LOADING,
  LAMBDATEST_TEST_DATA_REMOVE,
  LAMBDATEST_TEST_DATA_SUCCESS,
  LAMBDATEST_TEST_DATA_UPDATE,
  LAMBDATEST_TEST_DATA_UPDATE_SSE_EVENT,
  LAMBDATEST_TEST_SEARCH_CLEAR,
  LAMBDATEST_UPDATE_TESTDATA,
  LAMBDATEST_UPDATE_TESTNAME_CLEAR,
  SET_SHOULD_FILTER_UNIQUE_TESTS
} from "../actionTypeConstants/LambdaTestTestDataConstants";

import { getCookieData } from "../../utility/cookieHandler/handler";
import {
  getApiBaseUrl,
  isSharingRoute
} from "../../utility/utilityFunctions";

import cloneDeep from "lodash/cloneDeep";

const CancelToken = axios.CancelToken;
let source;
let flakyTestSource;

const timezoneOffset = getCookieData("timezoneOffset");
export let currentOffsetValue = 0;

export let lambdaFilterObject = [];

export let testApiCalllimit = 20;

export function fetchDefaultTestData(
  token,
  filter = [],
  minimal = false,
  offset = 0,
  limit = DEFAULT_TEST_DATA_API_CALL_LIMIT,
  jenkins = false,
  countTotalEnabled = false,
  shareId = "",
  automationApiHost,
  isNewCypressTestView
) {
  const mockApiEndpoint = automationApiHost || getApiBaseUrl();
  const mockApiClient = createRestApiClient().withConfig({
    baseURL: mockApiEndpoint
  }).client;
  currentOffsetValue = offset;
  testApiCalllimit = limit;
  let queryString = minimal === true ? `&minimal=true` : ``;

  queryString = isNewCypressTestView
    ? `${queryString}${queryString ? "&newTestView=true" : "newTestView=true"}`
    : queryString;

  if (source) {
    source.cancel("api request cancelled");
  }
  source = CancelToken.source();

  let filterToApply = cloneDeep(filter);

  let browserFilter = filterToApply["browser"];
  if (browserFilter && browserFilter?.length > 0) {
    const isEdgeAppliedIndex = browserFilter.findIndex(name => name === "edge");
    if (isEdgeAppliedIndex > -1) {
      filterToApply["browser"][isEdgeAppliedIndex] = "MicrosoftEdge";
    }
  }

  Object.keys(filterToApply).forEach(function(k) {
    if (filterToApply[k]) {
      if (filterToApply[k] instanceof Array) {
        if (filterToApply[k]?.length > 0) {
          if (k === "range" && !filterToApply.filterBy) {
            queryString = `${queryString}&${k}=${filterToApply[k].join(
              ","
            )}&filterBy=range`;
          } else {
            queryString = `${queryString}&${k}=${filterToApply[k].join(",")}`;
          }
        }
      }
      if (
        typeof filterToApply[k] === "string" ||
        filterToApply[k] instanceof String
      ) {
        if (filterToApply[k].trim() !== "") {
          if (k === "searchText") {
            queryString = `${queryString}&${k}=testName:${encodeURIComponent(
              filterToApply[k]
            )}`;
          } else {
            queryString = `${queryString}&${k}=${encodeURIComponent(
              filterToApply[k]
            )}`;
          }
        }
      }
    }
  });
  let cookieName = process.env.REACT_APP_COOKIE_NAME;
  let access_token = getCookieData(cookieName) || token;
  if (!access_token && !isSharingRoute()) {
    window.location.href =
      process.env.REACT_APP_LOGIN_URL || window?._env_?.REACT_APP_LOGIN_URL;
  }
  let header =
    isSharingRoute && shareId
      ? {
          "x-ml-auth": shareId,
          "x-ml-user": "sharing-client"
        }
      : { Authorization: `Bearer ` + access_token };
  if (jenkins) {
    const lambdaToken =
      getCookieData("lambdaToken") ||
      (jenkins.accessKeyData && jenkins.accessKeyData.apiToken);
    const username =
      getCookieData("username") ||
      (jenkins.accessKeyData && jenkins.accessKeyData.username);
    if (lambdaToken && username) {
      header = {
        Authorization: `Token ` + lambdaToken,
        username: username,
        Accept: "application/json"
      };
    }
  }
  let endPoint =
    queryString && queryString.trim() !== ""
      ? `/api/v2/test?timezone=${timezoneOffset}&offset=${offset}&limit=${limit}&${queryString}&includeCreated=0&caps=1`
      : `/api/v2/test?timezone=${timezoneOffset}&offset=${offset}&limit=${limit}&includeCreated=0&caps=1`;

  endPoint = endPoint + `&countEnable=${countTotalEnabled}`;
  if (isSharingRoute() && shareId) {
    endPoint = endPoint + `&shareId=${shareId}`;
  }
  let typesArray = [
    LAMBDATEST_TEST_DATA_LOADING,
    LAMBDATEST_TEST_DATA_SUCCESS,
    LAMBDATEST_TEST_DATA_FAILED
  ];
  return {
    payload: {
      isSharingRoute: isSharingRoute(),
      isNewUi: true
    },
    types: [...typesArray],
    promise: () =>
      mockApiClient.get(endPoint, {
        headers: header,
        cancelToken: source.token
      })
  };
}

export function clearSearchResults() {
  return dispatch =>
    dispatch({
      type: LAMBDATEST_TEST_SEARCH_CLEAR
    });
}

export function clearDefaultTestData() {
  return dispatch =>
    dispatch({
      type: LAMBDATEST_TEST_DATA_CLEAR
    });
}

export function updatetestdata(result, isNewCypressTestView) {
  let data = {};
  data.test = result;
  data.lambdaFilterObject = lambdaFilterObject;
  return dispatch =>
    dispatch({
      type: LAMBDATEST_TEST_DATA_UPDATE_SSE_EVENT,
      payload: data
    });
}

export const updateSidebarTest = data => {
  return dispatch =>
    dispatch({
      type: LAMBDATEST_UPDATE_TESTDATA,
      payload: data
    });
};

export const clearUpdateTestName = () => (dispatch: Dispatch) => {
  dispatch({
    type: LAMBDATEST_UPDATE_TESTNAME_CLEAR
  });
};

export const updateTestListData = (tests, isNewCypressTestView) => (
  dispatch: Dispatch
) => {
  dispatch({
    type: LAMBDATEST_SSE_TEST_LIST_DATA_UPDATE,
    payload: { tests, isNewCypressTestView }
  });
};

export const addTestData = newTest => (dispatch: Dispatch) => {
  dispatch({
    type: LAMBDATEST_TEST_DATA_ADD,
    payload: newTest
  });
};

export const updateTestData = updatedTest => (dispatch: Dispatch) => {
  dispatch({
    type: LAMBDATEST_TEST_DATA_UPDATE,
    payload: updatedTest
  });
};

export const fetchFlaxyTestsInABuild = buildId => {
  if (!buildId) {
    return;
  }
  const mockApiEndpoint = getApiBaseUrl();
  const mockApiClient = createRestApiClient().withConfig({
    baseURL: mockApiEndpoint
  }).client;
  const cookieName = process.env.REACT_APP_COOKIE_NAME;
  const access_token = getCookieData(cookieName);
  if (flakyTestSource) {
    flakyTestSource.cancel();
  }
  flakyTestSource = CancelToken.source();
  const types = [
    FETCH_FLAXY_TESTS_IN_BUILD_LOADING,
    FETCH_FLAXY_TESTS_IN_BUILD_SUCCESS,
    FETCH_FLAXY_TESTS_IN_BUILD_FAILED
  ];
  const headers = {
    Authorization: `Bearer ${access_token}`,
    Accept: "application/json"
  };
  const endPoint = `${process.env.REACT_APP_ANALYTICS_FLAKY_HOST}/build?build_id=${buildId}`;
  return {
    types: types,
    promise: () =>
      mockApiClient.get(endPoint, {
        headers: headers,
        cancelToken: flakyTestSource.token
      })
  };
};

export const removeTestData = updatedTest => (dispatch: Dispatch) => {
  dispatch({
    type: LAMBDATEST_TEST_DATA_REMOVE,
    payload: updatedTest
  });
};

export const setShouldFilterUniqueTests = shouldFilterUnique => (
  dispatch: Dispatch
) => {
  dispatch({
    type: SET_SHOULD_FILTER_UNIQUE_TESTS,
    payload: shouldFilterUnique
  });
};

export const deleteTestLocally = (testParam, isNewCypressTestView) => {
  return dispatch =>
    dispatch({
      type: LAMBDATEST_DELETE_TEST_LOCAL,
      payload: { testParam, isNewCypressTestView }
    });
};
